module.exports = __webpack_public_path__ + "static/media/slider_management.0351c980.jpg";